export default __webpack_public_path__ + "static/media/expandSideMenu.cfe04097.svg";